import { placeholderAnnouncementCity, placeholderAnnouncementDog, placeholderAnnouncementCat, placeholderCalendarEvent, placeholderCalendarEvent2, placeholderNeighbourhoodPerk } from 'data/mock';
import { Schema, SlotIdEnum, WidgetSizeEnum, WidgetTypeEnum } from 'types/schema';
import { getPlaceholderPhoto } from 'utils/get-placeholder-photo';

export const CalendarWeatherGalleryAnnouncementsSchema: Schema = [
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.Weather,
    widgetId: 'weather-1',
    slotId: SlotIdEnum.Slot2,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,
  },
  {
    widget: WidgetTypeEnum.Announcements,
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    widgetId: 'announcements-1',
    data: {
      announcements: [placeholderAnnouncementCity],
      backupImageUrl: undefined,
    },
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Announcements,
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    widgetId: 'announcements-1',
    data: {
      announcements: [placeholderAnnouncementCity],
      backupImageUrl: undefined,
    },
  },
];

const AnnouncementsGalleryCalendarPerksSchema: Schema = [
  {
    widget: WidgetTypeEnum.Announcements,
    widgetId: 'annoucements-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.HorizontalColumn,
    data: {
      announcements: [placeholderAnnouncementDog, placeholderAnnouncementCat],
      backupImageUrl: undefined,
    },
  },
  {
    widget: WidgetTypeEnum.Announcements,
    widgetId: 'annoucements-1',
    slotId: SlotIdEnum.Slot2,
    isCovered: true,
    size: WidgetSizeEnum.HorizontalColumn,
    data: {
      announcements: [placeholderAnnouncementDog, placeholderAnnouncementCat],
      backupImageUrl: undefined,
    },
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: [placeholderCalendarEvent],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.HorizontalColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.HorizontalColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.NeighborhoodPerks,
    widgetId: 'perks-1',
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: [placeholderNeighbourhoodPerk],
  },
];

const AnnouncementsWeatherGallerySchema = [
  {
    widget: WidgetTypeEnum.Announcements,
    widgetId: 'annoucements-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: {
      announcements: [placeholderAnnouncementDog],
      backupImageUrl: undefined,
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot2,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Weather,
    widgetId: 'weather-1',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
];

const GalleryCalendarPerksWeatherSchema = [
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot2,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.NeighborhoodPerks,
    widgetId: 'perks-1',
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: [placeholderNeighbourhoodPerk],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.Weather,
    widgetId: 'weather-1',
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,
  },
];

const Template1Schema = [
  {
    widget: WidgetTypeEnum.Weather,
    widgetId: 'weather-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot2,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-app-info.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Transportation,
    widgetId: 'transportation-1',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,   
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-app-info.jpg')],
      interval: '5',
    },
  },
];

const Template2Schema = [
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.HorizontalColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-skyscrapers.png')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot2,
    isCovered: true,
    size: WidgetSizeEnum.HorizontalColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-skyscrapers.png')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-2',
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-3',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-logo.png')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: [placeholderCalendarEvent],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-2',
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
];

const Template3Schema = [
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot2,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Weather,
    widgetId: 'weather-1',
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.SquareColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-city.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Transportation,
    widgetId: 'transportation-1',
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,
  },
];

const Template4Schema = [
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot1,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-app-info.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Announcements,
    widgetId: 'annoucements-1',
    slotId: SlotIdEnum.Slot3,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: {
      announcements: [placeholderAnnouncementDog],
      backupImageUrl: undefined,
    },
  },
  {
    widget: WidgetTypeEnum.Calendar,
    widgetId: 'calendar-1',
    slotId: SlotIdEnum.Slot4,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: [placeholderCalendarEvent, placeholderCalendarEvent2],
  },
  {
    widget: WidgetTypeEnum.RotationGallery,
    widgetId: 'gallery-1',
    slotId: SlotIdEnum.Slot5,
    isCovered: true,
    size: WidgetSizeEnum.FullColumn,
    data: {
      images: [getPlaceholderPhoto('placeholder-app-info.jpg')],
      interval: '5',
    },
  },
  {
    widget: WidgetTypeEnum.Weather,
    widgetId: 'weather-1',
    slotId: SlotIdEnum.Slot6,
    isCovered: true,
    size: WidgetSizeEnum.HalfColumn,
    data: null,
  },
];

export const templates = {
  CalendarWeatherGalleryAnnouncements: CalendarWeatherGalleryAnnouncementsSchema,
  AnnouncementsGalleryCalendarPerks: AnnouncementsGalleryCalendarPerksSchema,
  AnnouncementsWeatherGallery: AnnouncementsWeatherGallerySchema,
  GalleryCalendarPerksWeather: GalleryCalendarPerksWeatherSchema,
  Template1: Template1Schema,
  Template2: Template2Schema,
  Template3: Template3Schema,
  Template4: Template4Schema,
};

export type Template = keyof typeof templates;

export const templateOptions = [
  {
    label: 'Weather, Transportation, Events, Flyer',
    value: 'Template1',
  },
  {
    label: 'Image/PDF Rotation Gallery Middle, Building logo, Events, Image gallery',
    value: 'Template2',
  },
  {
    label: 'Image gallery, weather, transportation',
    value: 'Template3',
  },
  {
    label: 'Event calendar, Events flyer rotation, Announcement, Weather',
    value: 'Template4',
  },
  {
    label: 'Calendar, Weather, Gallery, Announcements',
    value: 'CalendarWeatherGalleryAnnouncements',
  },
  {
    label: 'Announcements, Gallery, Calendar, Perks',
    value: 'AnnouncementsGalleryCalendarPerks',
  },
  {
    label: 'Announcements, Weather, Gallery',
    value: 'AnnouncementsWeatherGallery',
  },
  {
    label: 'Gallery, Calendar, Perks, Weather',
    value: 'GalleryCalendarPerksWeather',
  },
];
